import Link from 'next/link';
import { SplideSlide } from '@splidejs/react-splide';
import styles from './BlogCarousel.module.scss';
import Carousel from '@/components/reusable/carousel/Carousel';
import BlogPostCard from '@/components/home/blogCarousel/blogPostCard/BlogPostCard';
import Icon from '@/components/UI/icon/Icon';
import Typography from '@/components/UI/typography/Typography';
import carouselSettings from './constants';
const BlogCarousel = ({
  blogPostList
}) => {
  return <section className={styles.blogCarousel} data-sentry-component="BlogCarousel" data-sentry-source-file="BlogCarousel.tsx">
      <header className={styles.blogCarousel_Header}>
        <Typography variant="bodyL_Bold" component={'h2'} data-sentry-element="Typography" data-sentry-source-file="BlogCarousel.tsx">
          مجله شب
        </Typography>
        <Link href={'https://blog.shab.ir'} className={styles.blogCarousel_ShowAllLink} target="_blank" rel="noreferrer" data-sentry-element="Link" data-sentry-source-file="BlogCarousel.tsx">
          بیشتر از مجله شب بخوانید
          <Icon name="arrow-left-1" type="primary" size={'small'} data-sentry-element="Icon" data-sentry-source-file="BlogCarousel.tsx" />
        </Link>
      </header>
      <Carousel opts={carouselSettings} data-sentry-element="Carousel" data-sentry-source-file="BlogCarousel.tsx">
        {blogPostList?.map(item => <SplideSlide key={item?.title}>
            <BlogPostCard title={item?.title} thumbnailPath={item?.thumbnail_path} link={item?.link} />
          </SplideSlide>)}
      </Carousel>
      <footer className={styles.blogCarousel_Footer}>
        <Link href={'https://blog.shab.ir'} className={styles.blogCarousel_ShowAllLink} target="_blank" rel="noreferrer" data-sentry-element="Link" data-sentry-source-file="BlogCarousel.tsx">
          بیشتر از مجله شب بخوانید
          <Icon name="arrow-left-1" type="primary" size={'small'} data-sentry-element="Icon" data-sentry-source-file="BlogCarousel.tsx" />
        </Link>
      </footer>
    </section>;
};
export default BlogCarousel;